import * as React from 'react'
import { ButtonProps, ButtonSizes, ButtonVariants } from './types'
import Wrapper from './Wrapper'
import Button from './styles/Button'
import ButtonWrapper from './styles/ButtonWrapper'
import ButtonOverlay from './styles/ButtonOverlay'
import ErrorIcon from './styles/ErrorIcon'
import SuccessIcon from './styles/SuccessIcon'
import { LoaderBall } from '../Loader/styles'
import buttonTheme from './styles/theme'

interface Options {
  size?: ButtonSizes
  variant?: ButtonVariants
}

const DolaButton: React.FC<ButtonProps> = ({
  children,
  error,
  loading = false,
  disabled = false,
  fillContainer,
  type = 'button',
  onClick,
  linkAttributes,
  theme = 'light',
  options: suppliedOptions,
  success,
  uppercase,
}) => {
  let options: Options = suppliedOptions as Options

  const variant = options?.variant
  const size = options?.size

  if (disabled && !(loading || success || error)) {
    options = { ...suppliedOptions, variant: 'disabled' }
  }

  return (
    <ButtonWrapper
      dolaTheme={theme}
      className="button-wrapper"
      fullWidth={!!fillContainer}
      size={size || 'medium'}
      variant={options?.variant}
    >
      <Wrapper {...linkAttributes}>
        <Button
          disabled={disabled || loading}
          fullWidth={!!fillContainer}
          type={type}
          dolaTheme={theme}
          className="dola-button"
          onClick={onClick}
          uppercase={uppercase}
          {...options}
        >
          {children}
          {loading && (
            <ButtonOverlay
              className="button-overlay"
              dolaTheme={theme}
              isLoading
              variant={variant}
            >
              <LoaderBall
                color={
                  buttonTheme[theme][suppliedOptions?.variant || 'primary'].text
                }
                className="button-overlay__loader-ball"
              />
              <LoaderBall
                color={
                  buttonTheme[theme][suppliedOptions?.variant || 'primary'].text
                }
                className="button-overlay__loader-ball"
                n={1}
              />
              <LoaderBall
                color={
                  buttonTheme[theme][suppliedOptions?.variant || 'primary'].text
                }
                className="button-overlay__loader-ball"
                n={2}
              />
            </ButtonOverlay>
          )}
          {success && (
            <ButtonOverlay
              className="button-overlay"
              dolaTheme={theme}
              variant={suppliedOptions?.variant}
            >
              <SuccessIcon
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="14"
                className="icon--button-success"
                viewBox="0 0 19 14"
                fill="none"
                size={size}
              >
                <path
                  d="M16.1824 1.3211L7.30818 10.2063L2.81761 5.71035C2.38994 5.28217 1.74843 5.28217 1.32075 5.71035C0.893082 6.13853 0.893082 6.78081 1.32075 7.20899L6.55975 12.4543C6.77359 12.6684 6.98742 12.7756 7.30818 12.7756C7.62893 12.7756 7.84277 12.6684 8.0566 12.4543L17.6792 2.82C18.1069 2.39181 18.1069 1.74954 17.6792 1.32136C17.2516 0.892923 16.6101 0.892923 16.1824 1.3211Z"
                  fill="white"
                  stroke="white"
                />
              </SuccessIcon>
            </ButtonOverlay>
          )}
          {error && (
            <ButtonOverlay
              className="button-overlay"
              dolaTheme={theme}
              variant={suppliedOptions?.variant}
            >
              <ErrorIcon
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-1 -1 15 15"
                fill="none"
              >
                <path
                  d="M12.5607 2.56064L8.62171 6.5L12.5607 10.4392C13.1466 11.0253 13.1466 11.9747 12.5607 12.5609C12.2679 12.8536 11.8841 13.0001 11.5005 13.0001C11.1162 13.0001 10.7324 12.8538 10.4399 12.5609L6.50006 8.62124L2.56055 12.5608C2.26784 12.8536 1.884 13.0001 1.50004 13.0001C1.1162 13.0001 0.732616 12.8538 0.439648 12.5608C-0.146251 11.975 -0.146251 11.0255 0.439648 10.4391L4.37848 6.49997L0.439424 2.56064C-0.146475 1.97474 -0.146475 1.02508 0.439424 0.43918C1.02521 -0.146271 1.97432 -0.146271 2.56033 0.43918L6.50002 4.37854L10.4394 0.43918C11.0255 -0.146271 11.9748 -0.146271 12.5604 0.43918C13.1466 1.02508 13.1466 1.97474 12.5607 2.56064Z"
                  fill="currentColor"
                />
              </ErrorIcon>
            </ButtonOverlay>
          )}
        </Button>
      </Wrapper>
    </ButtonWrapper>
  )
}

export default DolaButton
